module.exports = __webpack_public_path__ + "static/img/1.c570171.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/1.jpg
// module id = 717
// module chunks = 2